const PlyIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 7.00195C8 5.3451 9.34315 4.00195 11 4.00195H30.7574C31.553 4.00195 32.3161 4.31802 32.8787 4.88063L39.1213 11.1233C39.6839 11.6859 40 12.4489 40 13.2446V41.002C40 42.6588 38.6568 44.002 37 44.002H11C9.34315 44.002 8 42.6588 8 41.002V7.00195ZM38 14.002H31C30.4477 14.002 30 13.5542 30 13.002V6.00195H11C10.4477 6.00195 10 6.44967 10 7.00195V41.002C10 41.5542 10.4477 42.002 11 42.002H37C37.5523 42.002 38 41.5542 38 41.002V14.002Z'
        fill='#E0E2E7'
      />
      <path d='M8 19.002H40V31.002H8V19.002Z' fill='#3296B2' />
      <path
        d='M14.737 29V21.3H16.31L17.784 21.289C19.478 21.278 20.677 22.378 20.677 23.929C20.677 25.491 19.5 26.591 17.839 26.591H16.552V29H14.737ZM17.74 22.95H16.552V24.919H17.795C18.389 24.919 18.818 24.512 18.818 23.929C18.818 23.357 18.378 22.95 17.74 22.95ZM21.5153 29V21.3H23.3303V27.339H26.5863V29H21.5153ZM28.825 29V25.744L26.108 21.3H28.165L29.727 23.94L31.278 21.3H33.346L30.64 25.733V29H28.825Z'
        fill='white'
      />
    </svg>
  )
}

export default PlyIcon
